module.exports = __webpack_public_path__ + "img/flores_memorial_icone.a85fe6d2.png";